import React, { useState } from "react";
import { RefreshCw } from "lucide-react";

/**
 * Mobilde sağ altta duran yenile düğmesi.
 * Sistem web uygulaması olarak kullanıldığı için tarayıcının kendi yenile
 * düğmesi görünmüyor; bu düğme sayfayı baştan yükler.
 * `sm` (640px) ve üstünde gizlidir — masaüstünde tarayıcı çubuğu zaten var.
 *
 * `hidden`: alttaki toplu seçim çubuğu açıkken üst üste binmesin diye.
 */
export default function RefreshButton({ hidden = false }) {
  const [spinning, setSpinning] = useState(false);

  if (hidden) return null;

  const yenile = () => {
    setSpinning(true);
    window.location.reload();
  };

  return (
    <div
      className="sm:hidden fixed right-4 z-40 flex flex-col items-center gap-1"
      style={{ bottom: "calc(1rem + env(safe-area-inset-bottom))" }}
    >
      <button
        type="button"
        onClick={yenile}
        aria-label="Sayfayı yenile"
        data-testid="refresh-btn"
        className="h-11 w-11 rounded-full bg-white/90 dark:bg-neutral-900/90 backdrop-blur-md border border-neutral-200 dark:border-neutral-800 shadow-lg text-neutral-700 dark:text-neutral-200 flex items-center justify-center active:scale-95 transition-transform"
      >
        <RefreshCw className={`h-[18px] w-[18px] ${spinning ? "animate-spin" : ""}`} />
      </button>
      <span className="text-[10px] font-medium leading-none text-neutral-600 dark:text-neutral-300 bg-white/80 dark:bg-neutral-900/80 backdrop-blur-md px-1.5 py-1 rounded-full">
        Yenile
      </span>
    </div>
  );
}
